import React from 'react'
import Paper from 'material-ui/Paper'
import Grid from 'material-ui/Grid'
import Table from 'material-ui/Table'
import { TableBody } from 'material-ui/Table'
import { TableCell } from 'material-ui/Table'
import { TableHead } from 'material-ui/Table'
import { TableRow } from 'material-ui/Table'
import Icon from 'material-ui/Icon'
import { withStyles } from 'material-ui/styles'
import styles from './styles'
import FiberTable from '../components/fibertable'
import LengthTable from '../components/lengthdata'
import FiberImage from '../components/fiberimage'
import FiberHeader from '../components/fiberheader'
import FiberSetReferenceView from '../components/fibersetreferenceview'

class LoopbackFiber extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    const {
      classes,
      translate,
      chartMeasurementUnit,
      testresults,
      fiberLengthData,
      isbi,
      isloop,
      standard,
      configuration,
      results
    } = this.props

    const measurementUnit = chartMeasurementUnit === 'feet' ? '(ft)' : '(m)'

    return (
      <div ref="container">
        <FiberHeader
          classes={classes}
          results={results}
          translate={translate}
          fiberLengthData={fiberLengthData}
        />
        {testresults.map((result, key) => {
          return (
            <Paper className={classes.paper} key={key}>
              <h2 align="center">{translate("fiber_loopback_test", { value: key + 1 })}</h2>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12} align="center">
                <FiberImage
                  alt=""
                  src={'/images/bidirectional_loopback_B_A.png'}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <h1>{translate('fiber_insertionloss_heading')}</h1>
                <Grid container spacing={0}>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6} alignItems='flex-start'>
                    <h4 className={classes.fiberInfo}><strong>{translate('fibre_test_standard')}</strong> : {standard}</h4>
                  </Grid>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6} alignItems='flex-end'>
                    <h4 className={classes.fiberInfo}><strong>{translate('fibre_test_configuration')}</strong> : {configuration}</h4>
                  </Grid>
                </Grid>
                <FiberTable
                  result={result}
                  translate={translate}
                  isloop={isloop}
                />
              </Grid>
            </Paper>
          )
        })}


        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <h1>{translate('fiber_lengthdata')}</h1>
          <LengthTable
            fiberLengthData={fiberLengthData}
            translate={translate}
            chartMeasurementUnit={chartMeasurementUnit}
          />
        </Grid>

        {results.data.setreference ? 
        <FiberSetReferenceView 
          translate={translate}
          results={results} 
          chartMeasurementUnit={chartMeasurementUnit}
        /> : null}

      </div>
    )
  }
}

export default withStyles(styles)(LoopbackFiber)

